import { render } from "./App.vue?vue&type=template&id=2eba4d59&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2eba4d59&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2eba4d59"

export default script